// extracted by mini-css-extract-plugin
export default {"section":"logo_section__HaBOB","header":"logo_header__fzKBH","badge":"logo_badge__4Wpom","widgetWrap":"logo_widgetWrap__fyxMI","widget":"logo_widget__uJDfm"};